import { lenis } from './Scroll';

// ============================================
// フォーム
// ============================================

//住所自動入力
// ==========================
function addAutoFunc() {
  const zipInput = document.querySelector('[name="zip"]');
  const addInput = document.querySelector('[name="address"]');
  if (!zipInput || !addInput) return;

  zipInput.classList.add('p-postal-code');
  addInput.classList.add('p-region', 'p-locality', 'p-street-address', 'p-extended-address');

  new YubinBango.MicroformatDom();
}

// Contact form 7 確認画面
// ==========================
function confirmForm() {
  document.querySelectorAll('.wpcf7 form').forEach((form) => {
    if (form.dataset.cf7ConfirmBound === '1') return;

    //入力wrap
    const inputsWrap = form.querySelector('[data-inputs]');
    //確認wrap
    const confirmWrap = form.querySelector('[data-confirm]');

    //btn
    const toConfirm = form.querySelector('[data-to-confirm]');
    const toSendWrap = form.querySelector('[data-to-send]');
    const backBtn = form.querySelector('[data-back]');
    const sendBtn = form.querySelector('[data-send]');

    const cf7Submits = form.querySelectorAll('.wpcf7-submit');

    if (!inputsWrap || !confirmWrap || !toConfirm || !toSendWrap || !backBtn || !sendBtn || cf7Submits.length === 0) return;
    form.dataset.cf7ConfirmBound = '1';

    // 初期設定
    cf7Submits.forEach((submit) => {
      submit.style.display = 'none';
    });

    //便利関数作成
    const hide = (el) => {
      if (el) el.style.display = 'none';
    };
    const show = (el, displayType = '') => {
      if (el) el.style.display = displayType;
    };

    const disableSending = () => {
      sendBtn.disabled = true;
      sendBtn.setAttribute('aria-busy', 'true');
      cf7Submits.forEach((b) => {
        b.disabled = true;
        b.setAttribute('aria-busy', 'true');
      });
    };

    const enableSending = () => {
      sendBtn.disabled = false;
      sendBtn.removeAttribute('aria-busy');
      cf7Submits.forEach((b) => {
        b.disabled = false;
        b.removeAttribute('aria-busy');
      });
    };

    // 必須項目チェックバリデーション
    const validateBeforeConfirm = () => {
      form.querySelectorAll('input, select, textarea').forEach((el) => el.setCustomValidity?.(''));

      let firstInvalid = null;

      const nativeRequired = form.querySelectorAll('[name][required], [name][aria-required="true"]');
      nativeRequired.forEach((el) => {
        const name = el.name;
        if (!name) return;

        // オリジナルバリデーション
        // ※jsでのバリデーションのみは危険なので、必ずphpでもバリデーションをかけましょう(functions等)
        if (name === 'kana') {
          const value = (el.value ?? '').trim();

          // ひらがなのみ許可（長音「ー」、結合濁点、全角/半角スペース許可）
          // const VALID = /^[\u3041-\u3096\u3099-\u309C\u309D-\u309Fー\s\u3000]+$/;

          // カタカナのみ許可（長音「ー」、全角/半角スペース許可）
          const VALID = /^[\u30A1-\u30FA\u30FC\u30FD\u30FE\u30F6\u30FB\u30FC\s\u3000]+$/;

          if (value !== '' && !VALID.test(value)) {
            // el.setCustomValidity('ひらがなのみで入力してください');
            el.setCustomValidity('カタカナのみで入力してください');

            el.setAttribute('aria-invalid', 'true');
            el.classList.add('wpcf7-not-valid');

            if (!firstInvalid) firstInvalid = el;
          } else {
            el.setCustomValidity('');
            el.removeAttribute('aria-invalid');
            el.classList.remove('wpcf7-not-valid');
          }
        }

        //必須チェック
        if (el.tagName === 'SELECT') {
          if (!el.value) {
            el.setCustomValidity('この項目は必須です');
            if (!firstInvalid) firstInvalid = el;
          }
        } else if (el.type === 'checkbox' || el.type === 'radio') {
          const group = form.querySelectorAll(`input[name="${CSS.escape(name)}"]`);
          if (!Array.from(group).some((i) => i.checked)) {
            const head = group[0];
            head?.setCustomValidity?.('この項目は必須です');
            if (!firstInvalid) firstInvalid = head;
          }
        } else {
          if (!(el.value || '').trim()) {
            el.setCustomValidity('この項目は必須です');
            if (!firstInvalid) firstInvalid = el;
          }
        }
      });

      // CF7 特有 - チェックボックス／ラジオの必須はラッパーに付くからこちらでやる
      const cf7Groups = form.querySelectorAll('.wpcf7-form-control.wpcf7-checkbox.wpcf7-validates-as-required,' + '.wpcf7-form-control.wpcf7-radio.wpcf7-validates-as-required');
      cf7Groups.forEach((group) => {
        const inputs = group.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        if (inputs.length === 0) return;
        const isChecked = Array.from(inputs).some((i) => i.checked);
        if (!isChecked) {
          const head = inputs[0];
          head?.setCustomValidity?.('この項目は必須です');
          if (!firstInvalid) firstInvalid = head;
        }
      });

      const ok = form.reportValidity();
      if (!ok && firstInvalid) {
        requestAnimationFrame(() => {
          lenis.scrollTo(firstInvalid, { offset: -100, immediate: true });
        });
      }
      return ok;
    };

    // 確認画面に値を流し込む
    const populateConfirm = () => {
      const fd = new FormData(form);

      const names = new Set(
        Array.from(form.elements)
          .filter((el) => el.name)
          .map((el) => el.name)
      );

      names.forEach((name) => {
        const first = form.querySelector(`[name="${CSS.escape(name)}"]`);
        let value = '';

        if (first?.type === 'checkbox') {
          const values = fd.getAll(name);
          value = name === 'privacy' ? (values.length ? '同意する' : '未同意') : values.join(', ');
        } else if (first?.type === 'radio') {
          value = (fd.get(name) ?? '').toString();
        } else if (first?.tagName === 'SELECT' && first.multiple) {
          value = Array.from(first.selectedOptions)
            .map((o) => o.value)
            .join(', ');
        } else {
          value = (fd.get(name) ?? '').toString();
        }

        form.querySelectorAll(`[data-field="${CSS.escape(name)}"]`).forEach((slot) => {
          slot.textContent = value;
        });
      });
    };

    /** 入力 → 確認 **/
    toConfirm.addEventListener('click', (e) => {
      e.preventDefault();
      if (!validateBeforeConfirm()) return;
      populateConfirm();
      hide(inputsWrap);
      show(confirmWrap);
      hide(toConfirm);
      show(toSendWrap);
      lenis.scrollTo(0, { immediate: true });
    });

    /** 確認 → 戻る **/
    backBtn.addEventListener('click', (e) => {
      e.preventDefault();
      show(inputsWrap);
      hide(confirmWrap);
      show(toConfirm);
      hide(toSendWrap);
      lenis.scrollTo(0, { immediate: true });
    });

    /** CF7イベント関連 **/
    form.addEventListener('wpcf7beforesubmit', () => disableSending());

    // 送信失敗時の挙動
    const backToInputOnError = (e) => {
      const apiResponse = e.detail?.apiResponse;
      if (confirmWrap.style.display !== 'none') backBtn.click();

      const code = apiResponse?.code || apiResponse?.status;
      if (code === 'rest_invalid_nonce' || code === 'aborted') {
        try {
          window.wpcf7 && window.wpcf7.init && window.wpcf7.init(form);
        } catch (e) {}
      }

      enableSending();

      const wrap = form.querySelector('.c-form');
      const msg = form.querySelector('.wpcf7-response-output');
      if (msg) wrap.prepend(msg);
    };

    form.addEventListener('wpcf7invalid', (e) => backToInputOnError(e));
    form.addEventListener('wpcf7spam', (e) => backToInputOnError(e));
    form.addEventListener('wpcf7mailfailed', (e) => backToInputOnError(e));

    form.addEventListener('wpcf7submit', (e) => {
      const status = e.detail?.apiResponse?.status;
      if (status === 'mail_sent') {
        //成功時にリダイレクト
        const baseUrl = window.location.origin + window.location.pathname.replace(/\/+$/, '');
        window.location.href = `${baseUrl}/thanks/`;
      } else {
        backToInputOnError(e.detail?.apiResponse);
      }
      enableSending();
    });

    form.addEventListener('reset', () => {
      if (confirmWrap.style.display !== 'none') backBtn.click();
      enableSending();
    });
  });
}

//フォームの条件分岐
// ==========================
function branchSelectOther() {
  //ラジオcontactの値を取得する
  const contactValue = document.querySelectorAll('input[value="その他"]');
  const contactInput = document.querySelector('input[name="contact_other"]');

  if (contactValue.length !== 0 || contactInput) {
    function addReadonly() {
      contactInput.setAttribute('readonly', true);
    }
    addReadonly();

    contactValue.forEach((contactRadio) => {
      contactRadio.addEventListener('change', () => {

        // 一旦全部 readonly
        addReadonly();

       // 「お問い合わせ内容」
        if (
          contactRadio.name === 'contact_check' &&
          contactRadio.checked &&
          contactRadio.value === 'その他'
        ) {
          contactInput.removeAttribute('readonly');
        }
      });
    });
  }
}

export { addAutoFunc, confirmForm, branchSelectOther };
